// src/pages/dashboard/index.jsx
import React from "react";

const MemberDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"))?.user || {};

  return (
    <div className="space-y-6">
      {/* Welcome Card */}
      <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white shadow-xl">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold mb-2">স্বাগতম, {user.name}!</h1>
            <p className="text-white text-opacity-80 text-lg">
              আপনার প্রোফাইল তথ্য দেখুন ও আপডেট করুন
            </p>
          </div>
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center text-4xl font-bold">
            {(user.name || "U").charAt(0).toUpperCase()}
          </div>
        </div>
      </div>

      {/* Profile Information */}
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-900 flex items-center">
            <span className="w-2 h-2 bg-primary rounded-full mr-3"></span>
            প্রোফাইল তথ্য
          </h2>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                  <div className="w-8 h-8 bg-primary bg-opacity-20 rounded-lg flex items-center justify-center mr-3">
                    <svg
                      className="w-4 h-4 text-primary"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  ব্যক্তিগত তথ্য
                </h3>
                <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">নাম:</span>
                    <span className="font-semibold text-gray-900">
                      {user.name}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">মোবাইল:</span>
                    <span className="font-semibold text-gray-900">
                      {user.mobile}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">ইমেইল:</span>
                    <span className="font-semibold text-gray-900">
                      {user.email || "N/A"}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">জন্ম তারিখ:</span>
                    <span className="font-semibold text-gray-900">
                      {user.dob}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">রক্তের গ্রুপ:</span>
                    <span className="font-semibold text-primary bg-primary bg-opacity-10 px-2 py-1 rounded">
                      {user.bloodGroup}
                    </span>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                  <div className="w-8 h-8 bg-secondary bg-opacity-20 rounded-lg flex items-center justify-center mr-3">
                    <svg
                      className="w-4 h-4 text-secondary"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  ঠিকানা
                </h3>
                <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">বিভাগ:</span>
                    <span className="font-semibold text-gray-900">
                      {user.division}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">জেলা:</span>
                    <span className="font-semibold text-gray-900">
                      {user.district}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">উপজেলা:</span>
                    <span className="font-semibold text-gray-900">
                      {user.upazila}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">ইউনিয়ন:</span>
                    <span className="font-semibold text-gray-900">
                      {user.union}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                  <div className="w-8 h-8 bg-accent bg-opacity-20 rounded-lg flex items-center justify-center mr-3">
                    <svg
                      className="w-4 h-4 text-accent"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h2zM6 8H4v6h12V8h-2v1a1 1 0 11-2 0V8H8v1a1 1 0 11-2 0V8zM8 5v1h4V5a1 1 0 00-1-1h-2a1 1 0 00-1 1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  পেশাগত তথ্য
                </h3>
                <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">পদবী:</span>
                    <span className="font-semibold text-gray-900">
                      {user.designation}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">শিক্ষাগত যোগ্যতা:</span>
                    <span className="font-semibold text-gray-900">
                      {user.educationQualification}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">প্রতিষ্ঠান:</span>
                    <span className="font-semibold text-gray-900">
                      {user.institute}
                    </span>
                  </div>
                </div>
              </div>

              {user?.role !== "admin" && (
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                    <div className="w-8 h-8 bg-neutral bg-opacity-20 rounded-lg flex items-center justify-center mr-3">
                      <svg
                        className="w-4 h-4 text-neutral"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    অন্যান্য তথ্য
                  </h3>
                  <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">মাসিক ফি:</span>
                      <span className="font-semibold text-secondary bg-secondary bg-opacity-10 px-2 py-1 rounded">
                        {user.monthlyFee} টাকা
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">রক্তদানে আগ্রহী:</span>
                      <span
                        className={`font-semibold px-2 py-1 rounded ${
                          user.isAgreeDonateBlood
                            ? "text-secondary bg-secondary bg-opacity-10"
                            : "text-primary bg-primary bg-opacity-10"
                        }`}
                      >
                        {user.isAgreeDonateBlood ? "হ্যাঁ" : "না"}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">স্ট্যাটাস:</span>
                      <span className="font-semibold text-accent bg-accent bg-opacity-10 px-2 py-1 rounded">
                        {user.status}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberDashboard;
